module.exports = __webpack_public_path__ + "img/itemBottom.51bbb75b.jpg";